import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { forwardRef } from 'react';
export const FeatureTileFooter = forwardRef(({ variant, indicatorIcon, actionIcon, ...props }, ref) => (_jsxs(Stack, { direction: "horizontal", justify: indicatorIcon ? 'space-between' : 'flex-end', align: "center", ...props, ref: ref, children: [indicatorIcon?.({ variant }), actionIcon({ variant })] })));
FeatureTileFooter.displayName = 'FeatureTileFooter';
